import clsx from 'clsx';
import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { ReactNode, CSSProperties } from 'react';
import { HelpOutlineOutlined } from '@mui/icons-material';

import Tooltip from '../tooltip';
import { Placement } from '../tooltip/types';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  icon: {
    fontSize: theme.elements.icon.size.s,
    marginRight: theme.spacing(0.5)
  }
}));

interface Props {
  tooltip: NonNullable<ReactNode>;
  children: ReactNode;
  className?: string;
  tooltipPlacement?: Placement;
  offset?: [CSSProperties['offset'], CSSProperties['offset']];
}

const HelpInfoWrapper = ({ tooltip, children, className, tooltipPlacement, offset }: Props) => {
  const classes = useStyles();

  return (
    <Tooltip title={tooltip} placement={tooltipPlacement} offset={offset}>
      <Box className={classes.container}>
        <HelpOutlineOutlined className={clsx(classes.icon, className)} />
        {children}
      </Box>
    </Tooltip>
  );
};
export default HelpInfoWrapper;
